import { SET_CONTEXT, LOGIN_SUCCEEDED, LOGOUT_FAILED, LOGOUT_SUCCEEDED } from '../constants/actionTypes';
import { getDefaultContext } from '../../util/context';

const initialState = {
    context:  getDefaultContext(),
    token:    null,
    username: null
};

const reducer = ( state = initialState, action ) => {

    // console.log( 'reducers.auth', state, action );

    switch ( action.type ) {

        case SET_CONTEXT: {

            const { context } = action.payload;

            return { ...state, context };

        }

        case LOGIN_SUCCEEDED: {

            const { token, username } = action.payload;

            return { ...state, token, username };

        }

        case LOGOUT_FAILED:
        case LOGOUT_SUCCEEDED: {

            return initialState;

        }

        default:

            return state;

    }

};

export default reducer;